"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var classnames_1 = __importDefault(require("classnames"));
var html_to_react_1 = __importDefault(require("html-to-react"));
var react_1 = __importDefault(require("react"));
var SearchBar_styles_1 = require("./SearchBar.styles");
var constants_1 = require("../constants");
var Clock_1 = __importDefault(require("../icons/Clock"));
var Close_1 = __importDefault(require("../icons/Close"));
var Heart_1 = __importDefault(require("../icons/Heart"));
var Search_1 = __importDefault(require("../icons/Search"));
var htmlParser = html_to_react_1.default.Parser();
var SuggestionIcon = function (_a) {
    var type = _a.type;
    switch (type) {
        case constants_1.SearchType.SavedSearch:
            return react_1.default.createElement(Heart_1.default, null);
        case constants_1.SearchType.RecentSearch:
            return react_1.default.createElement(Clock_1.default, null);
        case constants_1.SearchType.TextSearch:
            return react_1.default.createElement(Search_1.default, null);
        default:
            return null;
    }
};
function Suggestions(_a) {
    var className = _a.className, getItemProps = _a.getItemProps, handleRemoveRecentSearch = _a.handleRemoveRecentSearch, handleSuggestionClick = _a.handleSuggestionClick, hasInput = _a.hasInput, highlightedIndex = _a.highlightedIndex, setHighlightedIndex = _a.setHighlightedIndex, suggestionResults = _a.suggestionResults;
    return suggestionResults.length ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex flex-col gap-8 bg-white', className), onMouseLeave: function () { return setHighlightedIndex(hasInput ? 0 : -1); } }, suggestionResults.map(function (item, index) { return (react_1.default.createElement("div", { className: "flex flex-col gap-8", key: "".concat(item.text).concat(index) },
        react_1.default.createElement("div", __assign({}, getItemProps({
            item: item,
            index: index
        })),
            react_1.default.createElement(merch_components_1.Clickable, { className: "flex cursor-pointer items-center justify-between rounded-[3px] transition-all duration-300", "data-analytics-id": "Search Bar - Suggestion", onClick: handleSuggestionClick, onMouseEnter: function () { return setHighlightedIndex(index); }, onTouchStart: function () { return setHighlightedIndex(index); }, style: {
                    backgroundColor: highlightedIndex === index
                        ? 'var(--cvna-color-grey-1)'
                        : 'var(--cvna-color-white)'
                } },
                react_1.default.createElement(SearchBar_styles_1.SuggestionItemWrapper, { title: item.text },
                    react_1.default.createElement("div", { className: "flex w-16 items-center" },
                        react_1.default.createElement(SuggestionIcon, { type: item.searchType })),
                    react_1.default.createElement("span", { className: "overflow-hidden text-ellipsis" }, htmlParser.parse(item.highlightedText))),
                item.searchType === constants_1.SearchType.RecentSearch && (react_1.default.createElement(SearchBar_styles_1.RecentSearchRemoveButton, { type: "button", onClick: handleRemoveRecentSearch, "data-analytics-id": "Search Bar - Remove Recent Search", value: item.text },
                    react_1.default.createElement(Close_1.default, null))))),
        hasInput && index === suggestionResults.length - 1 ? null : (react_1.default.createElement("div", { className: "w-full border-b border-grey-2" })))); }))) : null;
}
exports.default = Suggestions;
//# sourceMappingURL=Suggestions.js.map